module.exports = __webpack_public_path__ + "a2314fc9/img/delete-icon.eb7de062.svg";